//
//
//
//
//
//
//
//
//
//
//

	export default {
		data(){
			return {
//				louti:false,
//				zimu:null
			}
		},
		computed:{
			louti(){

				return this.$store.state.louti;
			},
			zimu(){
				return this.$store.state.zimu;
			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/xlouti.vue